// extracted by mini-css-extract-plugin
module.exports = {"signup-mgm__about":"About_signup-mgm__about__Ro0qc","signup-mgm__about__card":"About_signup-mgm__about__card__is7OL","text":"About_text__DpfPo","subtitle":"About_subtitle___Pkag"};